import React from 'react';
import {message} from 'antd'
import { useBnsGuangGaoFaBuStateMutation } from '../../store/ReactWebSiteApi';

function PublishState(props) {
    const [submit] = useBnsGuangGaoFaBuStateMutation();
    return (
        <>
            {props.bggfb_state==='1' ? <a 
                                    onClick={() => {
                                        submit({
                                            bggfb_id:props.bggfb_id,
                                            bggfb_state:'1',
                                        }).then((res) => {
                                            //console.log(res);
                                            if (res.data.Status === 'success') {
                                                message.success('取消审核成功！')  
                                            }
                                            if (res.data.Status === 'fail') {
                                                message.error('取消审核失败！'+res.data.Message)
                                            }
                                        })
                                    }}>待实现</a>:<a  
                                        onClick={() => {
                                            submit({
                                                bggfb_id:props.bggfb_id,
                                                bggfb_state:'2',
                                            }).then((res) => {
                                                //console.log(res);
                                                if (res.data.Status === 'success') {
                                                    message.success('审核成功！') 
                                                }
                                                if (res.data.Status === 'fail') {
                                                    message.error('审核失败！'+res.data.Message)
                                                }
                                            })
                                        }}>已实现</a>}
                                        
        </>
    )
}

export default PublishState